var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-inline--fa fa-vk fa-w-18",attrs:{"width":_vm.width || '1em',"height":_vm.height || '1em',"focusable":"false","data-prefix":"fab","data-icon":"vk","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512"}},[_c('path',{attrs:{"fill":"currentColor","d":_vm.svgPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }